import { render, staticRenderFns } from "./SearchInsufficientStockItem.vue?vue&type=template&id=56c967f2&scoped=true&"
import script from "./SearchInsufficientStockItem.vue?vue&type=script&lang=js&"
export * from "./SearchInsufficientStockItem.vue?vue&type=script&lang=js&"
import style0 from "./SearchInsufficientStockItem.vue?vue&type=style&index=0&id=56c967f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c967f2",
  null
  
)

export default component.exports